import React from 'react';
import { Outlet } from 'react-router-dom';

const TaxbillStaticsMngPage = () => {
  return <Outlet />;
};

export default TaxbillStaticsMngPage;
